import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InteractionsService } from 'src/app/services/interactions.service';
import { CommonsService } from 'src/app/services/common.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-interaction-page',
  templateUrl: './interaction-page.component.html',
  styleUrls: ['./interaction-page.component.scss']
})
export class InteractionPageComponent implements OnInit, OnDestroy {

  private interactionType: string;
  private interactionSlug: string;
  private interactionSubscriber;
  private interactions;
  public completed = false;
  public interaction;
  public language;

  constructor(
    private activatedRoute: ActivatedRoute,
    private interactionService: InteractionsService,
    private common: CommonsService,
    private router: Router,
    public deviceDetector: DeviceDetectorService
  ) {
    this.common.setHeader('interaction');
    this.language = localStorage.getItem('l')
  }

  ngOnInit(): void {
    const interactionType = this.activatedRoute.snapshot.params.type;
    const interactionSlug = this.activatedRoute.snapshot.params.slug;

    this.interactionSubscriber = this.interactionService.interactions$.subscribe(interactions => {
      if (!interactions) { // the main page was not been initializated
        // init the interactions Subject
        this.interactionService.getInteractions();
      } else {
        this.interactions = interactions;
        this.interaction = interactions.filter(int => int.url === interactionSlug)[0];
      }
    });

  }

  onResetInteraction() {
    this.interactionService.resetInteraction(this.interaction);
  }

  onComplete(interaction) {
    if (interaction.onComplete.contentType === 'redirect') {
      this.interaction = this.interactions.filter(int => int.id === interaction.onComplete.targetId)[0];
    } else {
      this.router.navigate(['/interaction-complete/', this.interaction.onComplete.contentType, this.interaction.id]);
    }
  }

  ngOnDestroy() {
    this.interactionSubscriber.unsubscribe();
  }

}
